import { Icon, IconProps } from "../Icon";

const ManifoldCircle = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 30.6275C23.732 30.6275 30 24.3594 30 16.6275C30 8.89547 23.732 2.62746 16 2.62746C8.26801 2.62746 2 8.89547 2 16.6275C2 24.3594 8.26801 30.6275 16 30.6275ZM5 12.5365H23.1441L26 15.8185L20.3182 21.6163H18.1553L20.4827 23.9911H15.2973L9.71381 18.2938H14.8992L16.4324 19.8583L19.9404 16.2788H8.28806L5 12.5365Z"
      fill="currentColor"
    />
  </Icon>
);

export default ManifoldCircle;
